export default "__VITE_ASSET__CVxbTVG$__"